import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FS3ValidationResult} from "../../objects/validationResult";
import {AppComponent} from "../../app.component";
import {ListItem} from "../../objects/listItem";
import {SharedDataService} from "../../services/shared-data.service";
import {FS3Notification} from "../../objects/notification";
import {User} from "../../objects/user";

@Component({
  selector: 'app-points-form',
  templateUrl: './points-form.component.html',
  styleUrls: ['./points-form.component.css']
})
export class PointsFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() profile: User;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  private formValidationMessages = {
    required: 'Value is required.',
    maxValueForbidden: 'Maximum allowed value is 9999.',
    onlyDigitsRequired: 'This should be numeric value.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public pointsInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  private isDblClick = false;

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.componentForm.addControl('pointsInput', this.pointsInput);
    //this.pointsInput.setValue(this.item.itemFullData['bonus_points']);
    this.pointsInput.setValue(this.profile.bonus_points);
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }
    if (this.isDblClick) {
      return false;
    }

    if (!this.pointsInput.valid) {
      const errorKey = Object.keys(this.pointsInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.pointsInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    }

    this.isDblClick = true;

    this.application.apiService
      .updateProfilePoints(this.pointsInput.value.trim(),this.profile.magic_key)
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'User points changed';
          this.sharedDataService.pushNotification(notification);
          //this.item.itemFullData['points'] = this.pointsInput.value.trim();
          this.profile.bonus_points = this.pointsInput.value.trim();
          this.success.emit()
        },
        error => {
          this.isDblClick = false;
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
            this.close.emit()
          } else {
            //maybe close dialog
          }
        }
      )

    return false
  }

  public onNoClick(): void {
    //this.dialogRef.close();
    this.close.emit()
  }

  private formValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value.toString().replace(/ /g, '');
      if (!value) {
        return {required: this.formValidationMessages.required}
      }

      if (isNaN(value*1) || parseFloat(value) != parseInt(value)) {
        return {onlyDigitsRequired: this.formValidationMessages.onlyDigitsRequired}
      }

      if (Math.abs(control.value) > 9999) {
        return {maxValueForbidden: this.formValidationMessages.maxValueForbidden}
      }

      return null;
    };
  }

}
